(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  function scrollToProductMedia() {
    const media = document.querySelector('media-gallery');

    if (!media) return;

    setTimeout(function () {
      media.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 150);
  }

  document.addEventListener('variant:update', scrollToProductMedia);
  document.addEventListener('variant:change', scrollToProductMedia);
  document.addEventListener('product:variant-change', scrollToProductMedia);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[type="radio"]') ||
      event.target.matches('select') ||
      event.target.closest('variant-picker') ||
      event.target.closest('product-form')
    ) {
      scrollToProductMedia();
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('variant-picker') ||
      event.target.closest('[data-option-value]') ||
      event.target.closest('input[type="radio"]') ||
      event.target.closest('button')
    ) {
      scrollToProductMedia();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
